import { useState, useEffect, useCallback } from "react";
import api from "../../../utils/api";
import { toast } from "react-toastify";

export const PAGE_SIZE = 10;

export const INIT_FILTERS = {
  orderId: "",
  username: "",
  phoneNumber: "",
  comment: "",
  joinedProductTitles: "",
  overallRating: "",
};

function buildApiFilters(filters) {
  const result = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== "" && value !== null) {
      result[key] = {
        value,
        matchMode: key === "overallRating" ? "equals" : "contains",
      };
    }
  });
  return result;
}

function enrichFeedback(fb) {
  return {
    ...fb,
    username: fb.user?.name || "NA",
    phoneNumber: fb.user?.phoneNumber || "NA",
    feedbackDate: fb.createdAt
      ? new Date(fb.createdAt).toLocaleString()
      : "NA",
  };
}

export function useFeedbacks() {
  const [feedbacks, setFeedbacks] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState(INIT_FILTERS);

  const load = useCallback(async (currentPage, currentFilters) => {
    setLoading(true);
    try {
      const res = await api.get("/feedbacks/loadfeedback", {
        params: {
          first: currentPage * PAGE_SIZE,
          rows: PAGE_SIZE,
          filters: JSON.stringify(buildApiFilters(currentFilters)),
        },
      });
      setFeedbacks((res.data.data || []).map(enrichFeedback));
      setTotalRecords(res.data.totalRecords || 0);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load feedback data");
    } finally {
      setLoading(false);
    }
  }, []);

  // React 18 batches these state updates, so only one re-render + one API call
  useEffect(() => {
    load(page, filters);
  }, [page, filters, load]);

  const setFilter = (key, value) => {
    setPage(0);
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const clearFilters = () => {
    setPage(0);
    setFilters(INIT_FILTERS);
  };

  const totalPages = Math.ceil(totalRecords / PAGE_SIZE);
  const activeFilterCount = Object.values(filters).filter(Boolean).length;

  return {
    feedbacks,
    totalRecords,
    loading,
    page,
    totalPages,
    filters,
    activeFilterCount,
    setPage,
    setFilter,
    clearFilters,
  };
}
